/**
 * Meta Pixel must run only on Lakewood's canonical public web hosts. Preview,
 * sandbox, and development hosts are intentionally excluded from paid-media data.
 */
export const LAKEWOOD_META_PRODUCTION_HOSTS = [
  "lakewoodmedspa.com",
  "www.lakewoodmedspa.com",
] as const;

export function isLakewoodMetaProductionHost(hostname: string | undefined): boolean {
  return LAKEWOOD_META_PRODUCTION_HOSTS.includes(
    (hostname ?? "").trim().toLowerCase() as (typeof LAKEWOOD_META_PRODUCTION_HOSTS)[number],
  );
}

/** Inline-safe gate for standalone HTML landing-page templates. */
export const META_TRACKING_HOST_GATE_SCRIPT = `
(function () {
  var allowedHosts = ['lakewoodmedspa.com', 'www.lakewoodmedspa.com'];
  var hostname = String((window.location && window.location.hostname) || '').toLowerCase();
  window.__lkwMetaTrackingAllowed = allowedHosts.indexOf(hostname) !== -1;
})();`.trim();
